import axios from "axios";
// import Vue from "vue";

// const baseDomain = `${process.env.VUE_APP_REST_API}`;
// const API_URL = `${process.env.VUE_APP_REST_API}`;

// const API = {
//   init() {
//     Vue.use(axios);
//     // axios.defaults.baseURL = API_URL;
//   },

//   get(resource, slug = "") {
//     return axios.get(`${resource}/${slug}`).catch(error => {
//       throw new Error(` [Get] ${error}`);
//     });
//   },

//   post(resource, data) {
//     return axios.post(`${resource}`, data);
//   }
// };

// export default API;

export const API = () => {
  const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 7000,
  });

  return instance;
};

export const register = (params) =>
  API().get("/v1/supplier/register", { params: params });

export const login = (params) =>
  API().post("/api/v3/public/supplier/login", params);

export const activate = (params) =>
  API().post("/api/v3/public/supplier/activate", params);

export const profile = (param) =>
  API().get("/v1/supplier/profile", { params: param });

export const file = (param) =>
  API().get("/v1/supplier/file", { params: param });

export const logout = (param) =>
  API().get("/v1/supplier/logout", { params: param });

export const update_profile = (params) =>
  API().get("/v1/supplier/update_profile", { params: params });

// export const upload_file = data =>
//   API().post("/v1/supplier/upload_file", data);

export const getCourses = (param) =>
  API().get("/v2/course/list", { params: param });

export const submitCousre = (data) => API().post("/v2/course/submit", data);

export const getCovidTests = (param) =>
  API().get("/api/v3/private/supplier/covid-test-results", {
    headers: {
      Authorization: `Bearer ${param.token}`,
    },
  });

export const createUpdateCovidTests = (param) =>
  API().post("/api/v3/private/supplier/covid-test-results", param, {
    headers: {
      Authorization: `Bearer ${param.token}`,
    },
  });
// export const CourseService = {
//   get(param) {
//     return API.get("course/list", param);
//   },

//   post(data) {
//     return API.post("course/submit", data);
//   }
// };

// export const SignUp = {
//   get(param) {
//     return API.get("v1/supplier/register", param, {
//       baseURL: process.env.VUE_APP_API_URL
//     });
//   }
// };

export const createTicketV3 = (params) => {
  const uri = "/api/v3/private/supplier/tickets";

  return API().post(uri, params, { stringify_data: false });
};
